import { makeStyles } from '@material-ui/core/styles';
import { colors } from '../../../theme/color-palette';
import { theme } from '../../../theme/theme';

import {
	BOGLE_REGULAR,
	BOGLE_BOLD,
	BOGLE_MEDIUM,
} from '../../../constants/constant';

const { LIGHT_GREY, DARK_GREY, PURPLE, TOGGLE_ACTIVE, GREY } = colors;

export const useStyles = makeStyles(() => ({
	applyBtn: {
		width: '68px  !important',
		color: `${colors.WHITE} !important`,
		fontFamily: `${BOGLE_BOLD} !important`,
		fontSize: '14px !important',
		height: '32px  !important',
		boxSizing: 'border-box !important',
		textTransform: 'capitalize !important',
		backgroundColor: `${colors.PURPLE} !important`,
		borderRadius: '50px !important',
		'&:disabled': {
			backgroundColor: `${colors.PURPLE_INACTIVE}  !important`,
		},
		'&:hover': {
			backgroundColor: `${colors.PURPLE_ACTIVE}  !important`,
		},
	},
	cancelBtn: {
		width: '68px  !important',
		backgroundColor: `${colors.WHITE} !important`,
		border: `${colors.LIGHT_GREY1} 1px solid !important`,
		fontFamily: `${BOGLE_BOLD} !important`,
		fontSize: '14px !important',
		boxSizing: 'border-box !important',
		height: '32px  !important',
		textTransform: 'capitalize !important',
		color: `${colors.PURPLE} !important`,
		borderRadius: '50px !important',
		'&:disabled': {
			backgroundColor: `${colors.PURPLE_INACTIVE}  !important`,
		},
		'&:hover': {
			backgroundColor: `${colors.HOVER_GRAY_SHADE}  !important`,
		},
	},
	timePeriodItem: {
		fontSize: 14,
		paddingTop: 0,
		paddingBottom: 0,
	},
	container: {
		fontFamily: BOGLE_MEDIUM,
		borderTopLeftRadius: '8px !important',
		borderTopRightRadius: '8px !important',
		paddingTop: 18,
		paddingBottom: 18,
		borderTop: `1px solid ${LIGHT_GREY} !important`,
		borderLeft: `1px solid ${LIGHT_GREY} !important`,
		borderRight: `1px solid ${LIGHT_GREY} !important`,
		flex: '1 !important',
		flexDirection: 'row !important',
		justifyContent: 'space-between !important',
		display: 'flex !important',
		alignItems: 'center !important',
		paddingLeft: '18px !important',
		paddingRight: '18px !important',
	},
	filtersContainer: {
		display: 'flex !important',
		flex: 1,
		flexDirection: 'row !important',
		[theme.breakpoints.down('md')]: {
			flexDirection: 'column !important',
		},
		gap: '16px !important',
	},
	label: {
		display: 'block !important',
		fontWeight: 'bold !important',
		fontFamily: BOGLE_BOLD,
		fontSize: '12px !important',
		textAlign: 'left !important',
		marginBottom: '5px !important',
		color: DARK_GREY,
	},
	ml20: {
		marginLeft: '20px !important',
		[theme.breakpoints.down('md')]: {
			marginTop: '10px !important',
			marginLeft: '0px !important',
		},
	},
	select: {
		fontFamily: BOGLE_REGULAR,
		fontSize: '14px !important',
		maxHeight: '324px !important',
		'& .MuiSelect-select': {
			fontFamily: BOGLE_REGULAR,
			display: 'flex !important',
			alignItems: 'center',
		},
		'& .MuiInputBase-root': {
			'& .Mui-focused': {
				'& .MuiOutlinedInput-notchedOutline': {
					borderColor: PURPLE + ' !important',
				},
			},
		},
		'& .MuiPaper-root': {
			maxHeight: '324px !important',
			width: '500px !important',
		},
	},
	menuList: {
		'& .MuiList-root': {
			maxHeight: '324px !important',
		},
	},
	listComparision: {
		'& .MuiAutocomplete-listbox .MuiAutocomplete-option[aria-selected="true"]':
			{
				backgroundColor: 'transparent !important',
			},
	},
	autcomplete: {
		minWidth: '200 !important',
		fontFamily: `${BOGLE_REGULAR} !important`,
		fontSize: '14px !important',
		'& .MuiAutocomplete-listbox .MuiAutocomplete-option[aria-selected="true"]':
			{
				backgroundColor: 'transparent !important',
			},
		'& .MuiFormControl-root': {
			fontFamily: `${BOGLE_REGULAR} !important`,
			'& .MuiOutlinedInput-root': {
				padding: '0px !important',
				paddingRight: '30px !important',
				paddingLeft: '2px !important',
				'& .MuiInputBase-input': {
					fontFamily: `${BOGLE_REGULAR} !important`,
					fontSize: '14px !important',
					paddingTop: '8px !important',
					paddingBottom: '8px !important',
					color: `${GREY} !important`,
					opacity: 1,
				},
				'& .MuiInputBase-input::placeholder': {
					color: `${GREY} !important`,
					opacity: 1,
				},
				'& .MuiInputBase-input::-ms-input-placeholder': {
					color: `${GREY} !important`,
					opacity: 1,
				},
				'& .MuiChip-root': {
					fontFamily: `${BOGLE_REGULAR} !important`,
					borderRadius: 2,
					backgroundColor: TOGGLE_ACTIVE,
					height: 13,
					paddingTop: '8px !important',
					paddingBottom: '8px !important',
				},
				'& .MuiSvgIcon-root': {
					color: GREY,
				},
				'& .MuiChip-deleteIcon': {
					fontSize: 13,
				},
			},
		},
		'& .MuiInputBase-root': {
			'& .Mui-focused': {
				'& .MuiOutlinedInput-notchedOutline': {
					borderColor: PURPLE + ' !important',
				},
			},
		},
	},
	breakdownfilter: {
		'& .MuiSelect-nativeInput': {
			opacity: 0,
			borderColor: 'transparent',
			borderWidth: 0,
			fontSize: 14,
			marginLeft: 8,
			marginBottom: 8,
			color: DARK_GREY,
		},
		'& .MuiSelect-nativeInput::placeholder': {
			color: DARK_GREY,
			opacity: 1,
		},
		'& .MuiSelect-nativeInput[value=""]': {
			opacity: 1,
		},
		'& .MuiSelect-nativeInput::-ms-input-placeholder': {
			color: DARK_GREY,
		},
		'& .MuiSelect-nativeInput[value=""]::placeholder': {
			color: GREY,
		},
		'& .MuiSelect-nativeInput[value=""]::-ms-input-placeholder': {
			color: GREY,
		},
	},
	formControl: {
		minWidth: '180px !important',
		'& label.Mui-focused': {
			color: PURPLE + ' !important',
		},
		'& .MuiOutlinedInput-root': {
			'&.Mui-focused fieldset': {
				borderColor: PURPLE + ' !important',
			},
		},
	},
	menuItem: {
		fontSize: '14px !important',
		fontFamily: BOGLE_REGULAR + ' !important',
		padding: '8px 16px !important',
		display: 'flex !important',
		justifyContent: 'flex-start !important',
		gap: '10px !important',
	},
	selectMenu: {
		'& .MuiList-root': {
			'& .MuiMenu-list': {
				padding: '8px !important',
				width: '279px !important',
			},
		},
		// '& .MuiPaper-root': {
		maxHeight: '100px !important',
		// },
		'& .MuiPaper-root': {
			width: '500px !important',
		},
	},
	searchField: {
		borderRadius: 4,
		border: `1px solid var(--Full-Color-Palette-Gray-Gray-30, #D5D6D8)`,
		background: `var(--Base-No-Contrast, #FFF)`,
		display: 'flex !important',
		height: '32px !important',
		// margin: '8px',
		// padding: '8px',
		width: '100%',

		'& .MuiInputBase-input': {
			padding: '8px 16px 8px 0px',
			lineHeight: '20px !important',
			fontSize: '14px !important',
			fontWeight: 400,
		},
		'& .MuiInputBase-root': {
			paddingLeft: '16px !important',
		},
	},
	'@global': {
		'& .MuiAutocomplete-popper': {
			'& .MuiPaper-root': {
				'& .MuiAutocomplete-listbox': {
					'& li': {
						fontSize: '14px !important',
						paddingTop: 0,
						paddingBottom: 0,
					},
				},
			},
		},
	},
}));
